module.exports = __webpack_public_path__ + "img/lg_ring_g_o_null_null@3x.4a94315c.png";